function createDateWithFullYear(year, month = 0, day = 1) {
	const date = new Date(2000, month, day);
	date.setFullYear(year, month, day);
	date.setHours(0, 0, 0, 0);
	return date;
}

export const minDeceasedDatePickerProps = {
	minDate        : createDateWithFullYear(0),
	minDateMessage : "La data non puo' essere precedente all'anno 0",
};